import * as C from '../Constants'
const InfoCardData = (state={}, action) => {
    switch(action.type){
        case C.LOAD_CARD:
            return{...state, cardLoading: true};
        case C.LOAD_CARD_SUCCESS:
            return{...state,
                cardData : action.stateWiseResp.statewise[0],
                tests: action.stateWiseResp.tested.slice(-1)[0],
                FullData: action.stateWiseResp.statewise.concat(action.stateWiseResp.statewise.shift()) ,
                cardLoading: false}  
        default:
            return state;  
    }
};
export default InfoCardData